var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import Button from '../button';
import Icon from '../icon';
import Popover from '../popover';
import { Styled } from './style';
var ButtonCheckbox = /** @class */ (function (_super) {
    __extends(ButtonCheckbox, _super);
    function ButtonCheckbox(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            var _a = _this.props, checked = _a.checked, onChange = _a.onChange, indeterminate = _a.indeterminate;
            /**
             * When status is indeterminated, it should always
             * change checked status to false next time
             */
            if (indeterminate) {
                onChange && onChange(false, false);
            }
            else {
                onChange && onChange(!checked, false);
            }
        };
        _this.renderButtonCheck = function () {
            var _a = _this.props, indeterminate = _a.indeterminate, checked = _a.checked, isCheckAll = _a.isCheckAll;
            var isDisplayAsChecked = checked || isCheckAll;
            var name = indeterminate ? ('checkbox-deselect') : isDisplayAsChecked ? ('checkbox-checked') : ('checkbox-empty');
            return (React.createElement(Button, { "data-testid": _this.props['data-testid'], icon: true, onClick: _this.handleClick, className: indeterminate || checked ? ('checked') : '', disabled: _this.props.disabled },
                React.createElement(Icon, { name: name })));
        };
        return _this;
    }
    ButtonCheckbox.prototype.render = function () {
        var _a = this.props, indeterminate = _a.indeterminate, checked = _a.checked, popover = _a.popover;
        return (React.createElement(Styled, null, popover ? (React.createElement(Popover, { trigger: this.renderButtonCheck(), content: indeterminate || checked ? popover[0] : popover[1], position: "top center", inverted: true })) : (this.renderButtonCheck())));
    };
    return ButtonCheckbox;
}(React.Component));
export default ButtonCheckbox;
//# sourceMappingURL=index.js.map